var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showRouterView)?_c('router-view'):_c('v-overlay',{attrs:{"value":true,"dark":false,"z-index":"9999"}},[_c('v-card',[_c('v-card-text',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',{attrs:{"size":25,"indeterminate":"","color":"primary"}}),_c('span',{staticClass:"mx-3 text-button"},[_vm._v("Loading user profile")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }